/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type PaymentType = 'Undefined' | 'Bankstatement' | 'Postalorder' | 'Sipo' | 'Other' | 'FinancialSettlement' | 'PennySettlement' | 'WriteOffOfReceivable';

export const PaymentType = {
    Undefined: 'Undefined' as PaymentType,
    Bankstatement: 'Bankstatement' as PaymentType,
    Postalorder: 'Postalorder' as PaymentType,
    Sipo: 'Sipo' as PaymentType,
    Other: 'Other' as PaymentType,
    FinancialSettlement: 'FinancialSettlement' as PaymentType,
    PennySettlement: 'PennySettlement' as PaymentType,
    WriteOffOfReceivable: 'WriteOffOfReceivable' as PaymentType
};